import { isWeb } from 'src/utils/platform';
import { isSeoCrawler } from 'src/utils/seo/isSeoCrawler';
/** Omits native-only object params on web so URLs match linking config. */
export default function buildEPQuestionNavParams(params) {
    if (isSeoCrawler) {
        return { questionID: params.questionID };
    }
    if (!isWeb) {
        return params;
    }
    const { examLevel, subject, question, qp, ...webParams } = params;
    return webParams;
}
